import { render, staticRenderFns } from "./LinkedinConfiguration.vue?vue&type=template&id=2dcca00a"
import script from "./LinkedinConfiguration.vue?vue&type=script&lang=js"
export * from "./LinkedinConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports